import * as React from "react";
import { StyleSheet, View } from "react-native";

import Layout from "@/layout/Layout";

import { useGroup } from "@/pages/group/GroupContext";

import { HardwareOrdersTable } from "./HardwareOrdersTable";

export const HardwareOrdersListPage: React.FC = () => {
  return (
    <Layout>
      <View style={styles.container}>
        <HardwareOrdersTable />
      </View>
    </Layout>
  );
};

export const GroupHardwareOrdersListPage: React.FC = () => {
  const { group } = useGroup();

  return (
    <Layout>
      <View style={styles.container}>
        <HardwareOrdersTable groupId={group.id} />
      </View>
    </Layout>
  );
};

const styles = StyleSheet.create({
  container: {
    margin: 16,
  },
});
